// 租户
import { $post,$patch } from '@/utils/http'
import Service from './Service'

// 接口集合
const _url = {
    // 获取租户
    GETLESSEEList: `/ucenter/v2/users/listhousehold`,
    // 添加租户
    ADDLESSEE: '/ucenter/v2/users/addhousehold',
    // 编辑租户
    EDITLESSEE: '/ucenter/v2/users/edithousehold',
    // 取消绑定租户
    DETELLESSEE: `/ucenter/v2/users/cancelhousehold`,
}

Service.getLesseeList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 建筑的id 顶层为0
    request['oid'] = params.oid;
    // 房间状态：1开户，2销户
    request['household_status'] = params.HouseholdStatus ? params.HouseholdStatus : 0;
	//是否为房间
	request['is_house'] = params.is_house;
	
    let data = await $post(_url.GETLESSEEList, request, true);
    return Service.handleCommonError(data)
}

Service.addLessee = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 房间ID
    request['houseid'] = params.houseid;
    // 业主名
    request['name'] = params.name;
    // 性别 1为男，2为女
    request['sex'] = params.sex;
    // 证件类别
    request['id_card'] = params.id_card;
    // 证件编码
    request['id_num'] = params.id_num;
    // 电话
    request['telephone'] = params.telephone;
    // 邮箱
    request['email'] = params.email;
    // 密码
    request['password'] = params.password;

    let data = await $post(_url.ADDLESSEE, request);
    return Service.handleCommonError(data)
}

Service.deleteLessee = async function (params) {
    let request = {}
    // 业主oid
    request['oid'] = params.OID;
    let data = await $post(_url.DETELLESSEE, request);
    return Service.handleCommonError(data)
}
Service.deleteLes = async function (params) {
    let request = {}
    // 业主oid
    request['oid'] = params.OID;
    let data = await $patch('/ucenter/v2/users/household/unbind', request);
    return Service.handleCommonError(data)
}

Service.editeLessee = async function (params) {
    let request = {}
    // 业主ID
    request['oid'] = params.oid;
    // 房间ID
    request['houseid'] = params.houseid;
    // 业主名
    request['name'] = params.name;
    // 性别 1为男，2为女
    request['sex'] = params.sex;
    // 证件类别
    request['id_card'] = params.id_card;
    // 证件编码
    request['id_num'] = params.id_num;
    // 电话
    request['telephone'] = params.telephone;
    // 邮箱
    request['email'] = params.email;
    // 密码
    request['password'] = params.password;

    let data = await $post(_url.EDITLESSEE, request);
    return Service.handleCommonError(data)
}

// 3-26：
// 新增住户绑定多个房间
Service.addMultiLessee = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 房间ID集合
    request['houseidlist'] = JSON.stringify(params.houseidlist);
    // 业主名
    request['name'] = params.name;
    // 性别 1为男，2为女
    request['sex'] = params.sex;
    // 证件类别
    request['id_card'] = params.IDCard;
    // 证件编码
    request['id_num'] = params.IDNum;
    // 电话
    request['telephone'] = params.telephone;
    // 邮箱
    request['email'] = params.email;
    // 密码
    request['password'] = params.password;

    let data = await $post("/ucenter/v2/users/addhouseholdhouselist", request);
    return Service.handleCommonError(data)
}

// 多个房间解绑住户
Service.delMultiLessee = async function (params) {
    let request = {}
   
    // 房间ID集合
    request['houseidlist'] = JSON.stringify(params.houseidlist);

    let data = await $post("/ucenter/v2/users/delhouseholdhouse", request);
    return Service.handleCommonError(data)
}

// 多个房间重新开户
Service.updataMultiLessee = async function (params) {
    let request = {}

    // 住户OID
    request['oid'] = params.oid
    // 房间ID集合
    request['houseidlist'] = JSON.stringify(params.houseidlist);

    let data = await $post("/ucenter/v2/users/householdbindhouse", request);
    return Service.handleCommonError(data)
}
// 充值
Service.recharge = async function (params) {
    let request = {}
	// 项目Id
	request['project_sys_id'] = Service.getProjectSystemId();
	if (!request['project_sys_id']) return;
    // 住户OID
    request['household_id'] = params.household_id
    // 充值额度
    request['money'] = params.money
	// 付款方式
	request['pay_type'] = params.pay_type

    let data = await $post("/ucenter/v2/users/household/recharge", request);
    return Service.handleCommonError(data)
}
// 提现
Service.withdrawdeposit = async function (params) {
    let request = {}
	// 项目Id
	request['project_sys_id'] = Service.getProjectSystemId();
	if (!request['project_sys_id']) return;
    // 住户OID
    request['household_id'] = params.household_id
    // 充值额度
    request['money'] = params.money
	// 付款方式
	request['pay_type'] = params.pay_type

    let data = await $post("/ucenter/v2/users/household/withdrawdeposit", request);
    return Service.handleCommonError(data)
}


// 修改住户信息
Service.editMultiLessee= async function (params) {
    let request = {}
    // 业主ID
    request['oid'] = params.oid;
    // 业主名
    request['name'] = params.name;
    // 性别 1为男，2为女
    request['sex'] = params.sex;
    // 证件类别
    request['id_card'] = params.IDCard;
    // 证件编码
    request['id_num'] = params.IDNum;
    // 电话
    request['telephone'] = params.telephone;
    // 邮箱
    request['email'] = params.email;
    // 密码
    request['password'] = params.password;

    let data = await $post("/ucenter/v2/users/edithousehold", request);
    return Service.handleCommonError(data)
}